import { countTruthy, isFunctionNative } from './helpers.js';

/**
 * @param {Window} window
 */
function checkBrowser(window) {
    const w = window;
    const n = navigator;

    function isDesktopWebKit() {
        const { HTMLElement, Document } = w;

        return (
            countTruthy([
                'safari' in w,
                !('ongestureend' in w),
                !('TouchEvent' in w),
                !('orientation' in w),
                HTMLElement && !('autocapitalize' in HTMLElement.prototype),
                Document && 'pointerLockElement' in Document.prototype,
            ]) >= 4
        );
    }

    function isSafariWebKit() {
        return (
            isFunctionNative(w.print) &&
            String(w.browser) === '[object WebPageNamespace]'
        );
    }

    function isWebKit() {
        return (
            countTruthy([
                'ApplePayError' in w,
                'CSSPrimitiveValue' in w,
                'Counter' in w,
                n.vendor.indexOf('Apple') === 0,
                'RGBColor' in w,
                'WebKitMediaKeys' in w,
            ]) >= 4
        );
    }

    function isWebKit606OrNewer() {
        return (
            countTruthy([
                'DOMRectList' in w,
                'RTCPeerConnectionIceEvent' in w,
                'SVGGeometryElement' in w,
                'ontransitioncancel' in w,
            ]) >= 3
        );
    }

    function isWebKit616OrNewer() {
        const { HTMLButtonElement } = w;

        return (
            countTruthy([
                !('getStorageUpdates' in n),
                HTMLButtonElement && 'popover' in HTMLButtonElement.prototype,
                'CSSCounterStyleRule' in w,
                window.CSS.supports('font-size-adjust: ex-height 0.5'),
                window.CSS.supports('text-transform: full-width'),
            ]) >= 4
        );
    }
    const desktopWebKitResult = isDesktopWebKit();
    const safariWebKitResult = isSafariWebKit();
    const webKitResult = isWebKit();
    const webKit606OrNewerResult = isWebKit606OrNewer();
    const webKit616OrNewerResult = isWebKit616OrNewer();

    return {
        isDesktopWebKit: desktopWebKitResult,
        isSafariWebKit: safariWebKitResult,
        isWebKit: webKitResult,
        isWebKit606OrNewer: webKit606OrNewerResult,
        isWebKit616OrNewer: webKit616OrNewerResult,
    };
}

export default checkBrowser;